"use client";

import { TextResources } from "@portal/assets/text/TextResources";
import Button from "@portal/components/atoms/v2/buttons/button";

const ReloadButton = () => (
  <Button
    text={TextResources.INVALID_SESSION_RELOAD_PAGE_BUTTON_TEXT}
    wide
    onClick={() => {
      window.location.reload();
    }}
  />
);

export default ReloadButton;
